import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import {
    QUIZ_DELETED,
    QUIZ_DELETING,
    QUIZ_DOWNLOADED,
    QUIZ_EDITING,
    QUIZ_PICTURE_FAILED,
    QUIZ_PICTURE_UPLOADING,
    QUIZ_POSTING,
    QUIZ_QUESTION_DOWNLOADED,
    QUIZ_QUESTION_PICTURE_FAILED,
    QUIZ_QUESTION_PICTURE_UPLOADING,
    QUIZ_RESET,
    QUIZZES_DOWNLOADED,
    QUIZZES_FAILED,
    QUIZZES_PENDING,
} from './types';
import { handleError } from '../infos/actions';

const cookies = new Cookies();

export const QuizzesPendingAction = () => {
    return {
        type: QUIZZES_PENDING,
    };
};

export const QuizzesDownloadedAction = (quizzes, lang) => {
    return {
        type: QUIZZES_DOWNLOADED,
        payload: {
            quizzes: quizzes,
            lang: lang,
        },
    };
};

export const QuizDownloadedAction = (quiz, lang) => {
    return {
        type: QUIZ_DOWNLOADED,
        payload: {
            quiz: quiz,
            lang: lang,
        },
    };
};

export const QuizDeletingAction = () => {
    return {
        type: QUIZ_DELETING,
    };
};

export const QuizDeletedAction = (quiz) => {
    return {
        type: QUIZ_DELETED,
        payload: {
            id: quiz.id,
        },
    };
};

export const QuizEditingAction = () => {
    return {
        type: QUIZ_EDITING,
    };
};

export const QuizResetAction = () => {
    return {
        type: QUIZ_RESET,
    };
};

export const QuizPostingAction = () => {
    return {
        type: QUIZ_POSTING,
    };
};

export const QuizPictureUploadingAction = () => {
    return {
        type: QUIZ_PICTURE_UPLOADING,
    };
};
export const QuizQuestionPictureUploadingAction = (question) => {
    return {
        type: QUIZ_QUESTION_PICTURE_UPLOADING,
        payload: {
            question: question,
        },
    };
};
export const QuizQuestionDownloadedAction = (quiz, question, lang) => {
    return {
        type: QUIZ_QUESTION_DOWNLOADED,
        payload: {
            quiz: quiz,
            question: question,
            lang: lang
        },
    };
};
export const QuizQuestionPictureFailedAction = (error) => {
    return {
        type: QUIZ_QUESTION_PICTURE_FAILED,
        payload: error,
    };
};

export function getQuizzes(app, lang) {
    return function (dispatch) {
        dispatch(QuizzesPendingAction());
        return APIService
            .getQuizzes(app, cookies.get('token'), lang)
            .then(quizzes => {
                dispatch(QuizzesDownloadedAction(quizzes, lang));
                return quizzes;
            })
            .catch(error => {
                dispatch(handleError(error, QUIZZES_FAILED));
            });
    };
}

export function postQuiz(app, quiz, lang) {
    return function (dispatch) {
        dispatch(QuizPostingAction());
        return APIService
            .postQuiz(app, quiz, cookies.get('token'), lang)
            .then(quiz => {
                dispatch(QuizDownloadedAction(quiz, lang));
                return quiz;
            })
            .catch(error => {
                dispatch(handleError(error, QUIZZES_FAILED));
            });
    };
}

export function putQuiz(app, quiz, lang) {
    return function (dispatch) {
        dispatch(QuizEditingAction());
        return APIService
            .putQuiz(app, quiz, cookies.get('token'), lang)
            .then(quiz => {
                dispatch(QuizDownloadedAction(quiz, lang));
                return quiz;
            })
            .catch(error => {
                dispatch(handleError(error, QUIZZES_FAILED));
            });
    };
}

export function deleteQuiz(app, quiz, lang) {
    return function (dispatch) {
        dispatch(QuizDeletingAction());
        return APIService
            .deleteQuiz(app, quiz, cookies.get('token'), lang)
            .then(() => {
                dispatch(QuizDeletedAction(quiz));
            })
            .catch(error => {
                dispatch(handleError(error, QUIZZES_FAILED));
            });
    };
}

export function postQuizPicture(app, quiz, picture, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(QuizPictureUploadingAction());
        return APIService.postQuizPicture(
            app,
            quiz,
            picture,
            cookies.get('token'),
            lang,
            onUploadProgress,
        ).then(quiz => {
            dispatch(QuizDownloadedAction(quiz, lang));
        }).catch((error) => {
            dispatch(handleError(error, QUIZ_PICTURE_FAILED));
        });
    };
}

export function deleteQuizPicture(app, quiz, lang) {
    return function (dispatch) {
        dispatch(QuizPictureUploadingAction());
        return APIService.deleteQuizPicture(
            app,
            quiz,
            cookies.get('token'),
            lang,
        ).then(quiz => {
            dispatch(QuizDownloadedAction(quiz, lang));
        }).catch((error) => {
            dispatch(handleError(error, QUIZ_PICTURE_FAILED));
        });
    };
}

export function postQuizQuestionPicture(app, quiz, question, picture, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(QuizQuestionPictureUploadingAction(question));
        return APIService.postQuizQuestionPicture(
            app,
            quiz,
            question,
            picture,
            cookies.get('token'),
            lang,
            onUploadProgress,
        ).then(newQuestion => {
            dispatch(QuizQuestionDownloadedAction(quiz, newQuestion, lang));
        }).catch((error) => {
            dispatch(handleError(error, QUIZ_QUESTION_PICTURE_FAILED));
        });
    };
}

export function deleteQuizQuestionPicture(app, quiz, question, lang) {
    return function (dispatch) {
        dispatch(QuizQuestionPictureUploadingAction(question));
        return APIService.deleteQuizQuestionPicture(
            app,
            quiz,
            question,
            cookies.get('token'),
            lang,
        ).then(newQuestion => {
            dispatch(QuizQuestionDownloadedAction(quiz, newQuestion, lang));
        }).catch((error) => {
            dispatch(handleError(error, QUIZ_QUESTION_PICTURE_FAILED));
        });
    };
}



// WEBPACK FOOTER //
// src/store/quizzes/actions.js